import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkEmailUnreadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mark_email_unread"}/>
}
